var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "text-s-left" }, [
      _c("h2", { staticClass: "sectionRooftitle text-left" }, [
        _vm._v("\n        " + _vm._s(_vm.trans("RELEASE_CALENDAR")) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex" },
        [
          _c(
            "h3",
            {
              staticClass: "h2 margin-bottom-15 text-left width50 width-s-100",
            },
            [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.trans("INFOGRAPHIC_RELEASE_CALENDAR_PLANNED")) +
                  "\n        "
              ),
            ]
          ),
          _vm._v(" "),
          !_vm.isMobile
            ? [
                _c(
                  "div",
                  {
                    staticClass:
                      "width50 flex flex--center flex--justifyContent-end",
                  },
                  [
                    _c("p", [
                      _vm._v(_vm._s(_vm.trans("XMO_HIGHLIGHTS_SHOW_ALL"))),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "highlightsToggleSwitch__wrapper highlightsToggleSwitch__wrapper--releaseLists display-inline-block",
                        attrs: { "aria-hidden": "true" },
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.filterReleases,
                              expression: "filterReleases",
                            },
                          ],
                          staticClass: "highlightsToggleSwitch__input",
                          attrs: {
                            id: `show${_vm.currentOutlook}`,
                            type: "checkbox",
                            "data-gtm": "highlightsToggleSwitch__input",
                          },
                          domProps: {
                            checked: Array.isArray(_vm.filterReleases)
                              ? _vm._i(_vm.filterReleases, null) > -1
                              : _vm.filterReleases,
                          },
                          on: {
                            change: function ($event) {
                              var $$a = _vm.filterReleases,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    (_vm.filterReleases = $$a.concat([$$v]))
                                } else {
                                  $$i > -1 &&
                                    (_vm.filterReleases = $$a
                                      .slice(0, $$i)
                                      .concat($$a.slice($$i + 1)))
                                }
                              } else {
                                _vm.filterReleases = $$c
                              }
                            },
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          { attrs: { for: `show${_vm.currentOutlook}` } },
                          [
                            _c("span", { staticClass: "visually-hidden" }, [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.trans(
                                      "RELEASE_CALENDAR_TOGGLE_CHECKBOX"
                                    )
                                  ) +
                                  "\n                        "
                              ),
                            ]),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm
                              .trans("XMO_HIGHLIGHTS_SHOW_MARKET")
                              .replace("{currentOutlook}", _vm.getMarketPrefix)
                          ) +
                          "\n                "
                      ),
                    ]),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }